<template>
  <div>
    <el-switch v-model="only_show_used"
               active-text="Only show used Data Sources"
               style="margin-bottom: 20px"
    />

    <el-table border :data="data_sources_for_table" style="width: 100%">
      <el-table-column
          prop="source_name"
          label="Data Source">
      </el-table-column>
      <el-table-column
          label="Take Action">
        <template slot-scope="scope">
          <el-button v-if="!!scope.row.extent_id" @click="editDataSource(scope.row.id)">Edit</el-button>
          <span v-else>Built in</span>
        </template>
      </el-table-column>
      <el-table-column
          label="Used in this extent">
          <template slot-scope="scope">
              {{ !!scope.row.used_in_extent ? 'Yes' : 'No'}}
          </template>
      </el-table-column>
      <el-table-column
          label="Columns">
          <template slot-scope="scope">
            <div v-for="column in scope.row.data_source_custom_fields">
              {{ column.field_name }}
            </div>
          </template>
      </el-table-column>
      <el-table-column
              label="Skip Rows">
          <template slot-scope="scope">
                  {{ scope.row.skip_rows }}
          </template>
      </el-table-column>
      <el-table-column
          label="API">
        <template slot-scope="scope">
          <span v-if="scope.row.api_nice">{{ scope.row.api_nice }}</span>
        </template>
      </el-table-column>
    </el-table>

    <el-button style="margin-top:30px" @click="createDataSource">
        Add Data Source
    </el-button>
  </div>
</template>

<script>
  export default {
    name: "ManageDataSources",
    props: [
        'extent_id'
    ],
    methods: {
      loadDataSources() {
        axios.get('/api/dataSources/' + this.extent_id)
          .then(response => {
              this.data_sources = response.data;
              // Don't include InventoryCaptainCrawl in data sources list
              this.data_sources = this.data_sources.filter(source => source.source_name !== "InventoryCaptainCrawl")
          }).catch(error => {
              console.log('error');
        })
      },
      editDataSource(id) {
        window.location.href = '/dataSource/' + this.extent_id + '/' + id;
      },
      createDataSource() {
        window.location.href = '/dataSource/' + this.extent_id;
      }
    },
    data() {
      return {
        data_sources: [],
        only_show_used: true
      }
    },
    computed: {
        data_sources_for_table: function () {
            if (this.only_show_used) {
                return this.data_sources.filter(source => source.used_in_extent);
            }

            return this.data_sources;
        }
    },
    created() {
      this.loadDataSources();
    }
  }
</script>

<style scoped>

</style>
